import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUp, faArrowDown, faMinus } from "@fortawesome/free-solid-svg-icons";

import AnimatedCounter from "./AnimatedCounter";

import { getPercentageValue } from "../../../utils/general";

export default function LiveKpiCard({
  label,
  icon,
  value,
  unit,
  trend,
  refLabel,
  variant = "cyan",
  format,
  decimals = 0,
}) {
  const cls = `lt-kpi lt-kpi--${variant}`;
  const direction = trend > 0 ? "up" : trend < 0 ? "down" : "flat";
  const arrow =
    direction === "up" ? faArrowUp : direction === "down" ? faArrowDown : faMinus;

  return (
    <div className={cls}>
      <span className="lt-kpi-corner" />
      <div className="lt-kpi-label">
        <FontAwesomeIcon icon={icon} />
        {label}
      </div>
      <div className="lt-kpi-value">
        <AnimatedCounter value={value} format={format} decimals={decimals} />
        {unit ? <span className="lt-kpi-unit">{unit}</span> : null}
      </div>
      <div className={`lt-kpi-trend ${direction}`}>
        <FontAwesomeIcon icon={arrow} />
        <strong>
          {Number.isFinite(trend)
            ? `${trend > 0 ? "+" : ""}${getPercentageValue(trend)}`
            : "-"}
        </strong>
        <span>vs {refLabel}</span>
      </div>
      <div className="lt-kpi-spark" />
    </div>
  );
}
